module.exports = __webpack_public_path__ + "media/images/curriculum_logo-ef15b968383d465b62dd757ed8027166.svg";